import { FC, useEffect, useRef, useState } from "react";
import { throttle } from "lodash";
import { QESButton } from "@app/shared/qes-standards/Button";
import { focusFirstInteractiveElement } from "@app/shared/utility/focusFirstInteractiveElement";

export const BackToTop: FC = () => {
  const [isVisible, setIsVisible] = useState(window.scrollY > 0);
  // equivalent of $qes-primary-gray-6
  const buttonBackground = useRef("#6e6e8b").current;
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const onScroll = throttle(() => {
      setIsVisible(() => window.scrollY > 0);
    }, 200);

    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const handleClick = () => {
    window.scrollTo({
      // auto relies on the app's scroll-behavior styling
      behavior: "auto",
      top: 0,
    });
    focusFirstInteractiveElement();
  }

  return (
    <QESButton
      qesType="none"
      qesTestId="back-to-top-button"
      className={`back-to-top-button${isVisible ? " appear" : ""}`}
      qesRef={buttonRef}
      onClick={handleClick}
    >
      <span className="visually-hidden">Return to Top</span>
      <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Return to Top. A white up arrow on a circular gray background.">
        <circle r="50" cx="50" cy="50" fill={buttonBackground} stroke={buttonBackground} shapeRendering="geometricPrecision" />
        <path d="M 38,57 L 50,45 62,57" stroke="white" strokeWidth="6" fill="transparent" />
      </svg>
    </QESButton>
  );
}